<template>
  <div class="companyBaseInfoDetail">
    <el-card class="box-card">
      <div class="back">
        <div></div>
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          size="small"
          @click="goBack"
          >返回</el-button
        >
      </div>
      <company-header
        :companyInfo="companyInfo"
        :scoreInfo="scoreInfo"
        :totalData="totalData"
        :type="'base'"
      ></company-header>
      <div class="basInfo-table model-info bg-w">
        <div class="row">
          <div class="title">
            <span>物业服务企业各指标计分情况</span>
          </div>
        </div>
        <div class="searchFrom">
          <el-form
            :inline="true"
            :model="searchParam"
            class="demo-form-inline"
            size="mini"
          >
            <el-form-item label="物业项目名称">
              <el-input
                v-model="searchParam.eaAreaName"
                placeholder="物业项目名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目负责人姓名">
              <el-input
                v-model="searchParam.mangerName"
                placeholder="项目负责人姓名"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="handleSearch"
                :loading="searchtBool"
                >搜索</el-button
              >
              <el-button type="primary" @click="handleClear">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          show-summary
          :summary-method="getSummaries"
          id="table"
          :fit="true"
          size="medium "
          max-height="600"
          :data="basicInfoList"
          border
          style="width: 100%"
          v-loading="loading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <template slot="empty">
            <span v-if="loading"></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column
            align="center"
            width="130"
            prop="address"
            fixed
            label="序号"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="170"
            prop="EaAreaName"
            fixed
            label="物业项目"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="130"
            prop="MangerName"
            fixed
            label="项目负责人"
          >
            <template slot-scope="scope">
              {{ scope.row.MangerName ? scope.row.MangerName : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="170"
            prop="ManagerScore"
            fixed
            label="项目负责人评价得分"
          >
            <template slot-scope="scope">
              {{
                scope.row.ManagerScore
                  ? scope.row.ManagerScore
                  : scope.row.ManagerScore === 0
                  ? scope.row.ManagerScore
                  : '-'
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="190"
            prop="MangerBindRate"
            label="项目负责人绑定情况(1分)"
          >
            <template slot-scope="scope">
              <div
                :style="
                  scope.row.MangerBindRate === 1
                    ? 'color:#40BA5E'
                    : 'color:#FE3535'
                "
              >
                {{ scope.row.MangerBindRate === 1 ? '已绑定' : '未绑定' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="190"
            prop="DataSupplementationRate"
            label="物业合同备案情况(10分)"
          >
            <template slot-scope="scope">
              <div
                :style="
                  scope.row.DataSupplementationRate === 1
                    ? 'color:#40BA5E'
                    : 'color:#FE3535'
                "
              >
                {{
                  scope.row.DataSupplementationRate === 1 ? '已备案' : '未备案'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="PublicRateFat"
            width="170"
            prop="NotificationResponseRate"
            label="通知发布响应率(5分)"
          >
          </el-table-column>
          <el-table-column
            align="center"
            :formatter="PublicRateFat"
            width="170"
            prop="SafetyCompletionRate"
            label="安全检查完成率(15分)"
          >
          </el-table-column>
          <el-table-column
            align="center"
            width="200"
            prop="IssOpen"
            label="共有资金开户情况(15分)"
          >
            <template slot-scope="scope">
              <div :style="scope.row.IssOpen ? 'color:#40BA5E' : ''">
                {{
                  scope.row.IssOpen
                    ? '已开户'
                    : scope.row.Open
                    ? '未开户'
                    : '--'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="170"
            prop="PublicRate"
            label="信息公开率(10分)"
          >
            <template slot-scope="scope">
              <!-- // 评价情况点进来显示100%(应公开数为0) -->
              <template v-if="scope.row.PublicDenominator === 0">
                100%(应公开数为0)
              </template>
              <template v-else>
                {{ (scope.row.PublicRate * 100).toFixed(2) }}%
              </template>
              <!-- {{
                scope.row.PublicDenominator === 0
                ? '应公开数为0'
                : (scope.row.PublicRate * 100).toFixed(2) + '%'
              }} -->
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :formatter="fnSatis"
            width="170"
            prop="SatisfactionScore"
            label="满意度得分(15分)"
          >
          </el-table-column>

          <el-table-column
            align="center"
            width="170"
            prop="EvaluationFeedbackRate"
            label="评价反馈率(8分)"
          >
            <template slot-scope="scope">
              {{
                scope.row.FeedbackAvg
                  ? (scope.row.EvaluationFeedbackRate * 100).toFixed(2) +
                    '%' +
                    '(平均分)'
                  : (scope.row.EvaluationFeedbackRate * 100).toFixed(2) + '%'
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="170"
            prop="CommunityEvaluateScore"
            label="街道社区评价(8分)"
          >
            <el-table-column
              align="center"
              width="170"
              prop="CommunityEvaluateScore"
              label="得分"
            >
              <template slot-scope="scope">
                <div
                  :style="
                    scope.row.CommunityEvaluateScore ? 'color:#40BA5E' : ''
                  "
                >
                  {{ scope.row.CommunityEvaluateScore }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              width="170"
              prop="CommunityEvaluateScore"
              label="是否默认"
            >
              <template slot-scope="scope">
                <div :style="scope.row.IssDefaultScore ? 'color:#40BA5E' : ''">
                  {{ scope.row.IssDefaultScore == true ? '是' : '否' }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            align="center"
            label="在管项目负责人的学历水平和从业经验(5分)"
          >
            <el-table-column
              align="center"
              :formatter="MangerEducation"
              width="170"
              prop="MangerEducation"
              label="项目负责人学历"
            >
            </el-table-column>
            <el-table-column
              align="center"
              :formatter="yearFat"
              width="170"
              prop="MangerWorkYear"
              label="项目负责人从业经验"
            >
              <template slot-scope="scope">
                <div :style="scope.row.NewWorkYear != '-' ? 'color:#40BA5E' : ''">
                  {{ scope.row.NewWorkYear }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            align="center"
            width="200"
            prop="ProfessionalCompletionRate"
            label="参与专业能力测评情况(2分)"
          >
            <template slot-scope="scope">
              <div>
                {{
                  Number(scope.row.ProfessionalCompletionRate * 100).toFixed(2)
                }}%
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="100"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <div class="page">
            <ps-page
              :page="pages"
              @getData="getCreditEvaBasicInfoList()"
            ></ps-page>
          </div>
        </div>
      </div>
      <div class="update-time">
        更新时间为 {{ new Date() | dateFormat('yyyy年MM月dd日 00:00:00') }}
      </div>
    </el-card>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import companyHeader from '../components/companyHeader.vue';
import filters from '@/filters/index';
import { educationEnum } from '@/enum/creditEvaluation';
import { RegularQueryController } from '@/service/newCreditEvaController/regularQueryController.js';
export default {
  name: 'companyBaseInfoDetail',
  components: {
    companyHeader,
  },
  data() {
    return {
      searchParam: {
        eaAreaName: '',
        mangerName: '',
      },
      scoreInfo: {},
      companyInfo: {},
      totalData: {},
      loading: false,
      basicInfoList: [],
      pages: new Page(),
      searchtBool: false,
      educationEnum: new educationEnum(),
      baseLoading: false,
    };
  },
  created() {
    //  获取列表数据
    this.regularQueryController = new RegularQueryController();
    this.keyId = this.$route.query.keyId || '';
    this.rankId = this.$route.query.rankId || '';
    this.orgName = this.$route.query.orgName
      ? decodeURIComponent(this.$route.query.orgName)
      : '';
    this.orgCode = this.$route.query.orgCode || '';
    this.getCreditEvaInformationVO();
    this.getCreditEvaRanking();
    this.getCreditEvaBasicInfoList();
    this.getCreditEvaBasicInfo();
  },
  filters: {
    dateFormat: filters.formatDate,
  },
  methods: {
    //格式化得分
    fnSatis(row, column, cellValue, index) {
      return row.SatisfactionAvg
        ? Number(cellValue).toFixed(2) + '(平均分)'
        : Number(cellValue).toFixed(2);
      // return Number(cellValue).toFixed(2);
    },
    //格式化百分比
    PublicRateFat(row, column, cellValue, index) {
      return (cellValue * 100).toFixed(2) + '%';
    },
    //格式化从业年限
    yearFat(row, column, cellValue, index) {
      return cellValue + '年';
    },
    //格式化学历
    MangerEducation(row, column, cellValue, index) {
      return cellValue === 0 ? '-' : this.educationEnum[cellValue];
    },
    //合计,等分情况
    getSummaries({ columns, data }) {
      const sum = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sum[index] = (
            <div>
              <div class="sum sum__t">合计</div>
              <div class="sum">得分情况</div>
            </div>
          );
          return;
        }
        switch (index) {
          case 1:
            sum[1] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum">-</div>
              </div>
            );
            break;
          case 2:
            sum[2] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum">-</div>
              </div>
            );
            break;
          case 8:
            sum[8] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.CommonAccountOpenRate * 100).toFixed(
                    2
                  )}
                  %
                  <el-tooltip placement="top">
                    <div slot="content">
                      计算规则
                      <br />
                      如企业/项目负责人没有应开共有资金账户的项目，统一按该项指标得分企业/项目负责人的平均分计分。
                    </div>
                    <i
                      class="el-icon-question"
                      style="margin-left: 6px;color: #a19a9a;font-size: 16px;"
                    />
                  </el-tooltip>
                </div>
                <div class="sum">
                  {Number(this.totalData.CommonAccountOpenRate * 15).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 3:
            sum[3] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum">-</div>
              </div>
            );
            break;
          case 4:
            sum[4] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.MangerBindRate * 100).toFixed(2)}%
                </div>
                <div class="sum">
                  {Number(this.totalData.MangerBindRate * 1).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 5:
            sum[5] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.DataSupplementationRate * 100).toFixed(
                    2
                  )}
                  %
                </div>
                <div class="sum">
                  {Number(this.totalData.DataSupplementationRate * 10).toFixed(
                    2
                  )}
                </div>
              </div>
            );
            break;
          case 10:
            sum[10] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.SatisfactionScore).toFixed(2)}
                </div>
                <div class="sum">
                  {Number(this.totalData.SatisfactionRate * 15).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 9:
            sum[9] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.PublicRate * 100).toFixed(2)}%
                </div>
                <div class="sum">
                  {Number(this.totalData.PublicRate * 10).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 7:
            sum[7] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.SafetyCompletionRate * 100).toFixed(2)}
                  %
                </div>
                <div class="sum">
                  {Number(this.totalData.SafetyCompletionRate * 15).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 11:
            sum[11] = (
              <div>
                <div class="sum sum__t">
                  {Number(this.totalData.EvaluationFeedbackRate * 100).toFixed(
                    2
                  )}
                  %
                </div>
                <div class="sum">
                  {Number(this.totalData.EvaluationFeedbackRate * 8).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 6:
            sum[6] = (
              <div>
                <div class="sum sum__t">
                  {Number(
                    this.totalData.NotificationResponseRate * 100
                  ).toFixed(2)}
                  %
                </div>
                <div class="sum">
                  {Number(this.totalData.NotificationResponseRate * 5).toFixed(
                    2
                  )}
                </div>
              </div>
            );
            break;
          case 15:
            sum[14] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum sum_col">
                  {Number(this.totalData.EmployeeSelectType * 5).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 12:
            sum[12] = (
              <div>
                <div class="sum sum__t">
                  {' '}
                  {Number(this.totalData.CommunityEvaluateScore).toFixed(2)}
                </div>
                <div class="sum sum_col">
                  {Number(this.totalData.CommunityEvaluateRate * 8).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 14:
            sum[14] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum sum_col">
                  {Number(this.totalData.EmployeeSelectType * 5).toFixed(2)}
                </div>
              </div>
            );
            break;
          case 16:
            sum[16] = (
              <div>
                <div class="sum sum__t">
                  {Number(
                    this.totalData.ProfessionalCompletionRate * 100
                  ).toFixed(2)}
                  %
                </div>
                <div class="sum">
                  {Number(
                    this.totalData.ProfessionalCompletionRate * 2
                  ).toFixed(2)}
                </div>
              </div>
            );
            break;

          case 13:
            sum[13] = (
              <div>
                <div class="sum sum__t">-</div>
                <div class="sum">-</div>
              </div>
            );
            break;
        }
      });
      this.$nextTick(() => {
        const tds = document.querySelectorAll('#table .el-table__footer tr>td');
        tds[14].colSpan = 2;
        tds[15].style.display = 'none';
      });
      return sum;
    },
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    },
    // 搜索
    handleSearch() {
      this.pages.currentPage = 1;
      this.getCreditEvaBasicInfoList();
    },
    // 重置
    handleClear() {
      this.searchParam.eaAreaName = '';
      this.searchParam.mangerName = '';
      this.getCreditEvaBasicInfoList();
    },
    // page相关
    handleSizeChange(val) {
      this.pages.currtNum = val;
      this.getCreditEvaBasicInfoList();
    },
    // page相关
    pageChange(val) {
      this.pages.currentPage = val;
      this.getCreditEvaBasicInfoList();
    },
    // 获取头部分数信息 keyId:String, dateTime:Date, bodyType:int, type:int
    getCreditEvaRanking() {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaRanking_builtBureauWebsite_v1(
          this.rankId,
          timeNow,
          1,
          1,
          this.orgCode,
          ''
        )
        .then((res) => {
          if (res) {
            this.scoreInfo = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取物业企业头部基础信息 mob:String, orgCode:String, type:String
    getCreditEvaInformationVO() {
      this.regularQueryController
        .getCreditEvaInformationVO_builtBureauWebsite_v1(
          '',
          this.orgCode,
          2,
          ''
        )
        .then((res) => {
          if (res) {
            this.companyInfo = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取列表数据token:String, cantonCode:String, streetOfficeOrgCode:String, residentsCommitteeOrgCode:String, name:String, mob:String,
    // eaAreaName:String, haveAccount:int, exceptions:int, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
    getCreditEvaBasicInfoList() {
      this.loading = true;
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaBasicInfoList_builtBureauWebsite_v1(
          timeNow,
          this.orgName,
          this.searchParam.mangerName,
          this.searchParam.eaAreaName,
          this.orgCode,
          '',
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          true,
          2,
          0,
          1,
          ''
        )
        .then((res) => {
          this.loading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            this.basicInfoList = res._Items;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 基础信息得分情况合计 keyId:String, dateTime:Date, orgCode:String, personName:String, personTel:String, bodyType:int
    getCreditEvaBasicInfo() {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaBasicInfo_builtBureauWebsite_v1(
          this.keyId,
          timeNow,
          this.orgCode,
          '',
          '',
          1,
          ''
        )
        .then((res) => {
          if (res) {
            this.totalData = res;
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 查看详情
    handleDetails(row) {
      this.$router.push({
        path: '/officialCompanyBaseInfoDetailPenetrate',
        query: {
          wyqydm: row.EaAreaCode,
          bodyType: 1, // 1：企业，2：项目负责人
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.companyBaseInfoDetail {
  width: 100%;
  height: 800px;

  .back {
    display: flex;
    justify-content: space-between;
  }

  .model-info {
    background: #fff;
    overflow: hidden;

    .row {
      .title::after {
        background: #e40413;
      }

      .scoring-rules {
        cursor: pointer;
      }

      .link {
        color: #1890ff;
        cursor: pointer;
      }
    }

    // .row-table{
    //     overflow: scroll;
    //     .add-w{
    //         min-width: 150px !important;
    //     }
    // }
    .footer {
      float: right;
    }
  }
  .update-time {
    padding-bottom: 8px;
  }
}

.searchFrom {
  margin: 16px 0 0 20px;
}

.row-table {
  overflow: scroll;

  .add-w {
    min-width: 170px !important;
  }

  .reduce-w {
    min-width: 100px !important;
  }
}

.title::after {
  background: #e40413 !important;
}

//给固定列设置下边距
.el-table {
  .el-table__fixed {
    height: auto !important;
    bottom: 8px !important; //具体值是多少根据你横向滚动条的高度进行设置
  }
}
//去掉固定列下方的横线
.el-table__fixed::before,
.el-table__fixed-right::before {
  display: none;
}

/deep/::-webkit-scrollbar {
  width: auto;
  height: auto;
  background: transparent;
}
/deep/::-webkit-scrollbar-button {
  display: block;
}


/deep/#table {
  // 滚动条高度调整
  ::-webkit-scrollbar {
      height: 10px;
  }
  .el-table__fixed,
  .el-table__fixed-left, .el-table__fixed-right {
      pointer-events: none;
      td {
          pointer-events: auto;
      }
  }
}
</style>
